import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Conteiner = styled.div`
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;
	height: 80vh;
	width: 35vw;
	padding-left: 2rem;
	padding-right: 2rem;
	background-color: #FAFAFA;

	@media screen and (max-height: 782px) {
		width: 50vw;
		height: 90vh;
	}

	@media screen and (max-height: 666px) {
		width: 60vw;
		height: 100vh;
	}
`;
